
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Vue } from "vue-class-component";
import generateManifest from "./manifest-pdf";
import { ClearanceDetailData } from "@/domain/entities/Clearance";
import {
  formatPriceRP
} from "@/app/infrastructures/misc/Utils";
export default class PrintManifestClearance extends Vue {
  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }

  printManifest(dataDetail: ClearanceDetailData) {
    // logo
    const element: any = document;
    const logo = element.getElementById("logo")?.src;


    // handle data
    const data: any = [];

    dataDetail.clearanceDetailStt.forEach((item, index) => {
      data.push({
        no: index + 1,
        bagNo: "",
        sttNo: "",
        grossWeight: "",
        goodsPrice: "",
        commodityType: "",
        originCity: "",
        destCity: "",
      });
      const bagNo = data[index].clearanceBagNo ? "\n\n" : "";
      const sttNo = data[index].clearanceSttNo ? "\n\n" : "";
      const grossWeight = data[index].clearanceSttWeight ? "\n\n" : "";
      const goodsPrice = data[index].clearanceSttGoodsPrice ? "\n\n" : "";
      const commodityType = data[index].clearanceSttCommodityName ? "\n\n" : "";
      const originCity = data[index].clearanceOriginCity ? "\n\n" : "";
      const destCity = data[index].clearanceDestinationCity ? "\n\n" : "";

      data[index] = {
        ...data[index],
        bagNo: `${data[index].bagNo}${bagNo}${item.clearanceBagNo}`,
        sttNo: `${data[index].sttNo}${sttNo}${item.clearanceSttNo}`,
        grossWeight: `${data[index].grossWeight}${grossWeight}${item.clearanceSttWeight} Kg`,
        goodsPrice: `${data[index].goodsPrice}${goodsPrice}${formatPriceRP(item.clearanceSttGoodsPrice, "MYR")}`,
        commodityType: `${data[index].commodityType}${commodityType}${item.clearanceSttCommodityName}`,
        originCity: `${data[index].originCity}${originCity}${item.clearanceOriginCity}`,
        destCity: `${data[index].destCity}${destCity}${item.clearanceDestinationCity}`,
      };
    });
    generateManifest(dataDetail, data, logo);
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }
}
